import React from 'react'

import { PaddingProps } from 'styled-system'

import { ProjectPreview, SectionWrapper } from 'Components/Blocks'
import { Row, Text } from 'Components/UI'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'
import { LOCAL_PROJECTS } from 'Constants/Projects/localProjects'

type Props = PaddingProps

function OurNotoriousCasesSection({ ...rest }: Props) {
  return (
    <SectionWrapper px={0} {...rest}>
      <Row px={LANDING_INLINE_PADDINGS}>
        <Text as="h2" mb={17} medium title title40>
          Our notorious cases
        </Text>
      </Row>

      {LOCAL_PROJECTS.map((item, index) => (
        <ProjectPreview data={item} isFirst={index === 0} key={item.id} />
      ))}
    </SectionWrapper>
  )
}

export default OurNotoriousCasesSection
